import { GenericModel } from "../../generic.model";
import { HostModel } from "../common/host.model";
import { makeModel } from "../../../service/utils/utils.service";
import { WhenModel } from "../common/when.model";
import { ActionModel } from "./action.model";

export class TransactionModel extends GenericModel {
    public actionArray: ActionModel[];
    public hostArray: HostModel[];
    public key: string;
    public transactionId: string;
    public when: WhenModel;
    public xSeverity: string;
    public xTarget: string;
    // TODO control: {hostArray: [{code: "ALAMO", shortcut: "ALM", xTarget: "Test"}],…}
    // TODO style: {currency: {currencyCode: "EUR", decimals: 2, default: true}, output: {xType: "XFT"},…}

    protected fromJson(json?: any): boolean {
        this.actionArray = makeModel(json.actionArray, ActionModel);
        this.hostArray = makeModel(json.hostArray, HostModel);
        this.key = json.key ?? null;
        this.transactionId = json.transactionId ?? null;
        this.when =  makeModel(json.when, WhenModel);// {value: "2022-08-16T15:36:42.19899+02:00", date: "2022-08-16", time: "15:36:42"}
        this.xSeverity = json.xSeverity ?? null;
        this.xTarget = json.xTarget ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.transactionId !== null;
    }
}